import React from 'react'
import CompanyDetailCard from '../../components/Companies/CompanyDetailCard'
import { Col, Row, Space } from 'antd'
import Proposals from '../../components/Companies/Proposals'
import './Company.scss';

const CompanyDetail = () => {
    return (
        <div style={{paddingBottom:120}}>
                    <Space direction="vertical" size={32} style={{width:'100%' }}>
                        <CompanyDetailCard />
                        {/* <Proposals /> */}
                    </Space>
        </div>
    )
}

export default CompanyDetail
